import { render, staticRenderFns } from "./CertificatesTable.vue?vue&type=template&id=835f74f4"
import script from "./CertificatesTable.vue?vue&type=script&lang=js"
export * from "./CertificatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports